module.exports = __webpack_public_path__ + "img/multiplier.68fb1fa3.png";